import {Persona} from './persona';

export class Perfil {
  public idPerfil: number;
  public nombre;
}

export class Usuario extends Persona {
  public id: number;
  public usuario = '';
  public clave = '';
  public estado = '';
  /*public capctcha:String ="";*/
  public perfil: Perfil = new Perfil;
  public sesion: string;
}

export class Contrasenia {
  public usuario = '';
  public password = '';
  public newpassword = '';
}

// interface
